module.exports = __webpack_public_path__ + "static/img/product-design.e196eac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product-design.png
// module id = x27I
// module chunks = 1